module.exports = __webpack_public_path__ + "static/media/Program7.47c0052b.jpg";